import { container } from '../di/Container';
import { TRACKER_TOKEN } from '../di/tokens';
import type { DestinationTracker } from '../di/types';

export function useTravelataTracker(): DestinationTracker | null {
  return container.has(TRACKER_TOKEN) ? container.resolve(TRACKER_TOKEN) : null;
}
